import { GeneticSex } from '~/graphql/gen/graphql';

export type GeneticSexFormValue = 'female' | 'male' | 'unspecified';

export function normalizeGeneticSex(
  value: GeneticSex | GeneticSexFormValue,
): GeneticSex {
  if (value === 'female') {
    return GeneticSex.Female;
  }

  if (value === 'male') {
    return GeneticSex.Male;
  }

  if (value === 'unspecified') {
    return GeneticSex.Unknown;
  }

  return value;
}

export function toGeneticSexFormValue(
  sex: GeneticSex | 'FEMALE' | 'MALE' | 'UNKNOWN',
): GeneticSexFormValue {
  const value = typeof sex === 'string' ? sex : sex;

  switch (value) {
    case GeneticSex.Female:
    case 'FEMALE': {
      return 'female';
    }

    case GeneticSex.Male:
    case 'MALE': {
      return 'male';
    }

    default: {
      return 'unspecified';
    }
  }
}
